import type { HeaderService, ListItem } from '@patsnap-utils/biz';
import { Site, SLD } from '@patsnap-utils/biz';
import '@patsnap-ui/icon/assets/solid/HistoryRecord.svg';
import '@patsnap-ui/icon/assets/userpackage.svg';
import '@patsnap-ui/icon/assets/solid/rocket.svg';
import '@patsnap-ui/icon/assets/solid/AI.svg';

type ILocale = 'cn' | 'en' | 'tw' | 'jp'

export interface CustomLinksOptions {
    isFreemium: boolean;
    isPersonal: boolean;
    locale: ILocale;
}

export async function customProductsLinkInUserCenter(headerService: HeaderService, options: CustomLinksOptions) {
    const locale = options.locale || 'en';
    const buildin = headerService.userCenterService.beforeRenderMenuItems;

    headerService.userCenterService.beforeRenderMenuItems = function beforeRenderMenuItems(items: ListItem[]) {
        const _items = buildin(items);
        _items.splice(1, 0, {
            href: new Site({ sld: SLD.EUREKA, pathname: 'history' }).href,
            label: ({
                cn: '历史记录',
                en: 'History',
                jp: '履歴',
                tw: '歷史記錄',
            })[locale],
            icon: 'SolidHistoryRecord',
            key: 'history',
        });

        // 根据用户类型决定"所有版本"的跳转地址
        const versionPath = options?.isPersonal
            ? 'user-setting/package/management'
            : 'user-setting/package/ip';

        _items.splice(0, 0, {
            href: new Site({ sld: SLD.EUREKA, pathname: versionPath }).href,
            label: ({
                cn: '所有版本',
                en: 'All versions',
                jp: 'すべてのバージョンになります',
                tw: '所有版本',
            })[locale],
            icon: 'SolidRocket',
            key: 'version',
        });

        _items.splice(0, 0, {
            href: new Site({ sld: SLD.EUREKA, pathname: 'user-setting/amount' }).href,
            label: ({
                cn: '用量',
                en: 'Usage',
                jp: '利用回数',
                tw: '用量',
            })[locale],
            icon: 'Userpackage',
            key: 'package',
        });

        // 个人用户过滤特定菜单项
        if (options.isPersonal) {
            const nonePackages = ['package', 'settings', 'team']
            return _items.filter(item => !nonePackages.includes(item.key as string));
        }

        return _items;
    };
}
